import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Placeholder from 'components/consumer/Placeholder';
import classNames from 'classnames';
import PDPChooseYourOptionsPlaceholder from '../PDPChooseYourOptions/PDPChooseYourOptionsPlaceholder';
import PDPProtectionPlanSelectorPlaceholder from '../PDPProtectionPlanSelector/PDPProtectionPlanSelectorPlaceholder';
import PDPAddToBagSectionPlaceholder from '../PDPAddToBagSection/PDPAddToBagSectionPlaceholder';
import PDPSellingAttributesPlaceholder from '../PDPSellingAttributes/PDPSellingAttributesPlaceholder';
import PDPProductDescriptionPlaceholder from '../PDPProductDescription/PDPProductDescriptionPlaceholder';
const PDPMobilePlaceholder = t0 => {
  const $ = _c(12);
  const {
    className: parentClassName
  } = t0;
  let t1;
  if ($[0] !== parentClassName) {
    t1 = classNames("flex flex-col flex lg:hidden", parentClassName);
    $[0] = parentClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Placeholder className="my-1.5" loading={true} type="rect" style={{
      width: "200px",
      height: "24px"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Placeholder className="mb-4" loading={true} type="rect" style={{
      width: "180px",
      height: "18px"
    }} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Placeholder className="mb-1.5" loading={true} type="rect" style={{
      width: "72px",
      height: "24px"
    }} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]">{t2}{t3}{t4}<Placeholder className="mb-3" loading={true} type="rect" style={{
        width: "180px",
        height: "18px"
      }} /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Placeholder className="mb-1.5" loading={true} type="rect" style={{
      width: "100vw",
      aspectRatio: "1/1"
    }} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Placeholder className="mb-1.5" loading={true} type="rect" style={{
      width: "100vw",
      height: "60px"
    }} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Placeholder className="mb-1.5" loading={true} type="rect" style={{
      width: "100vw",
      aspectRatio: "1/1"
    }} />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]"><PDPChooseYourOptionsPlaceholder /><PDPProtectionPlanSelectorPlaceholder /><PDPAddToBagSectionPlaceholder /><PDPSellingAttributesPlaceholder /><PDPProductDescriptionPlaceholder className="mb-1.5" /></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t1) {
    t10 = <div className={t1}>{t5}{t6}{t7}{t8}{t9}</div>;
    $[10] = t1;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  return t10;
};
export default PDPMobilePlaceholder;